/* Night Game lineup carousel: spotlight focus + infinite loop + autoplay */
(function () {
  function initLineup() {
    var t = document.getElementById('nglin-track');
    if (!t || t.__ngl) return;
    var orig = [].slice.call(t.children);
    var N = orig.length;
    if (N < 2) return;
    t.__ngl = 1;
    var wrap = document.getElementById('nglin-wrap');
    var f1 = document.createDocumentFragment(), f2 = document.createDocumentFragment();
    orig.forEach(function (c) { f2.appendChild(c.cloneNode(true)); });
    orig.forEach(function (c) { f1.appendChild(c.cloneNode(true)); });
    t.appendChild(f2);
    t.insertBefore(f1, t.firstChild);
    var kids = [].slice.call(t.children);
    function co(i) { var k = kids[i]; return k.offsetLeft + k.offsetWidth / 2 - t.clientWidth / 2; }
    var idx = N;
    function go(i, sm) { t.scrollTo({ left: co(i), behavior: sm ? 'smooth' : 'auto' }); }
    var raf;
    function foc() {
      var c = t.scrollLeft + t.clientWidth / 2, best = 1e9, bi = 0;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i], kc = k.offsetLeft + k.offsetWidth / 2, d = Math.abs(kc - c);
        if (d < best) { best = d; bi = i; }
      }
      for (var j = 0; j < kids.length; j++) { kids[j].classList.toggle('on', j === bi); }
      return bi;
    }
    var wt;
    t.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(foc);
      clearTimeout(wt);
      wt = setTimeout(function () {
        var bi = foc(); idx = bi;
        if (idx < N) { idx += N; go(idx, false); }
        else if (idx >= 2 * N) { idx -= N; go(idx, false); }
      }, 150);
    });
    function nx() { idx++; go(idx, true); }
    function pv() { idx--; go(idx, true); }
    var p = document.getElementById('nglin-prev'), n = document.getElementById('nglin-next');
    if (p) p.addEventListener('click', function (e) { e.preventDefault(); pv(); });
    if (n) n.addEventListener('click', function (e) { e.preventDefault(); nx(); });
    var au = setInterval(nx, 3800);
    function stop() { clearInterval(au); }
    function start() { stop(); au = setInterval(nx, 3800); }
    if (wrap) {
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('touchstart', stop, { passive: true });
    }
    setTimeout(function () { go(idx, false); foc(); }, 60);
    window.addEventListener('resize', function () { go(idx, false); });
  }
  function boot() { initLineup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  var tries = 0, iv = setInterval(function () {
    tries++;
    initLineup();
    var el = document.getElementById('nglin-track');
    if ((el && el.__ngl) || tries > 24) clearInterval(iv);
  }, 250);
})();
